import { atom } from "recoil";

export const cartState = atom({
  key: "cartState",
  default: [],
});

// Keep the order being edited with the cart while navigating through the menu.
export const cartOrderContextState = atom({
  key: "cartOrderContextState",
  default: {},
});
